import React from 'react';
import { motion } from 'framer-motion';
const volumes = [{
  num: '1',
  title: '3 Bände: Das Master-System',
  desc: 'Der komplette Leitfaden für jede Phase Ihrer Saison — von der Stationswahl bis zur Ausrüstung. Mit Preistabellen, Karten und Geheimtipps Station für Station.'
}];
const sections = [{
  num: '02',
  title: 'Der SBB-Experten-Kalender',
  desc: 'Die ultimative Lösung für SBB-Bürokratie: Exakte Buchungsfenster, Tarif-Tabellen und Monat-für-Monat Sparpläne nach den offiziellen SBB-Richtlinien.'
}, {
  num: '03',
  title: 'Der Interaktive Alpen-Kompass',
  desc: 'GPS-Koordinaten für alle 20 Stationen. Gratis-Parkplätze, Hütten-Empfehlungen und geheime Pisten-Zugänge. Offline nutzbar.'
}, {
  num: '04',
  title: 'Alpine Identity Guide',
  desc: 'Lernen Sie die sozialen Codes der Schweizer Berghütten. So werden Sie wie ein Einheimischer behandelt — und bekommen Tische, Tipps und Preise, die Touristen nie sehen.'
}];
export function TomiSection() {
  return <section className="py-10 sm:py-12 px-4 bg-[#0d0d17] border-t border-brand-orange/10" data-id="element-280">
      <div className="max-w-xl mx-auto" data-id="element-281">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-8" data-id="element-282">
          <h2 className="text-2xl sm:text-3xl font-black text-brand-cream mb-3" data-id="element-283">
            Was genau drin steckt
          </h2>
          <p className="text-sm text-gray-400 font-medium" data-id="element-284">
            Das "Swiss Peak" Archiv im Detail.
            <br data-id="element-285" />
            Digitale Werkzeuge als PDF — heute noch auf Ihr Smartphone laden.
          </p>
        </motion.div>

        {/* Section 01 — Volumes */}
        <div className="mb-8" data-id="element-286">
          <div className="flex items-center gap-3 mb-5" data-id="element-287">
            <span className="text-brand-orange font-black text-sm tracking-widest" data-id="element-288">
              01
            </span>
            <span className="text-gray-600" data-id="element-289">|</span>
            <h3 className="text-base sm:text-lg font-black text-brand-cream uppercase" data-id="element-290">
              PDF
            </h3>
          </div>

          <div className="space-y-3" data-id="element-291">
            {volumes.map((v, i) => <motion.div key={i} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.05
          }} className="bg-brand-card border border-white/10 p-4 rounded-xl" data-id="element-292">
                <div className="flex items-start gap-3" data-id="element-293">
                  <div className="bg-brand-orange text-white text-xs font-black px-2.5 py-1 rounded shrink-0" data-id="element-294">
                    VOL {v.num}
                  </div>
                  <div data-id="element-295">
                    <h4 className="font-bold text-brand-cream text-sm sm:text-base mb-1" data-id="element-296">
                      {v.title}
                    </h4>
                    <p className="text-xs sm:text-sm text-gray-400 leading-snug" data-id="element-297">
                      {v.desc}
                    </p>
                  </div>
                </div>
              </motion.div>)}
          </div>
        </div>

        {/* Sections 02-04 */}
        <div className="space-y-4 mb-8" data-id="element-298">
          {sections.map((s, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-brand-card border border-brand-orange/20 p-5 rounded-2xl" data-id="element-299">
              <div className="flex items-center gap-3 mb-2" data-id="element-300">
                <span className="text-brand-orange font-black text-sm tracking-widest" data-id="element-301">
                  {s.num}
                </span>
                <span className="text-gray-600" data-id="element-302">|</span>
                <h3 className="text-base font-black text-brand-cream uppercase" data-id="element-303">
                  {i === 0 ? 'PDF kompilierbar' : i === 1 ? 'Digitale Karte' : 'Training'}
                </h3>
              </div>
              <h4 className="font-bold text-brand-cream text-sm sm:text-base mb-1" data-id="element-304">
                {s.title}
              </h4>
              <p className="text-sm text-gray-400 leading-snug" data-id="element-305">{s.desc}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}